<template>
  <q-dialog
    ref="modal"
    noBackdropDismiss
    noEscDismiss
    @cancel="$emit('cancel')"
  >

    <span slot="title">2-Faktor-Authentifizierung bestätigen</span>

    <span slot="message">
      Bitte bestätigen Sie den Vorgang mit dem Code aus Ihrer<br>
      Authentifizierungs-App:
    </span>

    <div slot="body">
      <q-field
        :count="6"
      >
        <q-input
          v-model="otp"
          float-label="Code"
          maxlength="6"
        />
      </q-field>
    </div>

    <div slot="buttons" slot-scope="props" class="q-px-sm q-pb-sm full-width row">
      <q-btn flat color="blue" label="Zugang verloren?" :disabled="loading" @click="start2FaRecovery" />
      <div class="col"></div>
      <q-btn flat color="dark" label="Abbrechen" :disabled="loading" @click="props.cancel" />
      <q-btn
        color="primary"
        label="Bestätigen"
        :disabled="!otp || otp.length !== 6"
        :loading="loading"
        @click="onOk"
      />
    </div>

  </q-dialog>
</template>

<script>
/**
 * @example
 * this.$q.modal(VerifyOtpLoginModal)
 *
 * @returns promise which resolves if otp entered and rejects on cancel or error
 */

export default {
  name: 'VerifyOtpLoginModal',
  props: ['payload'],
  data: () => ({
    loading: false,
    otp: '',
  }),
  watch: {
    otp(val) {
      if (val && val.length === 6 && /^\d+$/.test(val)) {
        this.onOk();
      }
    },
  },
  methods: {
    async show() {
      this.$refs.modal.show();
    },
    async onOk() {
      this.loading = true;

      const user = await this.$store.dispatch('auth/login', {
        ...this.payload,
        otp: this.otp,
      });

      if (!user) {
        this.loading = false;
        return;
      }

      this.$refs.modal.hide();
      this.$emit('ok', user);
      this.loading = false;
    },
    async start2FaRecovery() {
      try {
        await this.$axios.post('/v2/security/otp/reset', this.payload);
        this.$notifyUserInteraction.info('Eine E-Mail zum Zurücksetzen der 2-Faktor-Authentifizierung wurde versendet!');
        this.$refs.modal.hide();
        this.$emit('cancel');
      } catch (error) {
        console.error(error);
        this.$notifyUserInteraction.error('Ein unbekannter Fehler ist beim Zurücksetzen der 2-Faktor-Authentifizierung aufgetreten!');
      }
    },
  },
};
</script>
